import React from 'react';
import { Grid, Button } from '@material-ui/core';

const Home = (props) => {
    const buttonStyle = {
        width : '30%'
    }

    const button =
    {
        textTransform: "none"
    }


    return (


        <Grid container spacing={2}>
            <Grid container justify="center">
                <Grid item >
                    <h1>Welkom!</h1>
                </Grid>
            </Grid>
            <Grid container justify="center">
                <Grid item>
                    <Grid container justify="center">
                        <Grid item>
                            <Button color="primary" variant="contained" size="large" onClick={() => props.history.push('reg')}>
                                Registreer
                </Button>
                        </Grid>
                    </Grid>
                    <br/>
                    <Grid item>
                        <Grid container justify="center">
                            <Grid item>
                                <Button color="primary" variant="contained" size="large" onClick={() => props.history.push('tekenin')}>
                                    Teken In
                            </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

    );
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js